import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {ColorLegendEntry} from './color-legend.types';

@Component({
  selector: 'app-color-legend',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoPipe],
  templateUrl: './color-legend.component.html',
})
export class ColorLegendComponent {
  readonly entries = input.required<ColorLegendEntry[]>();
}
